module.exports = __webpack_public_path__ + "img/kmdxfsde.1f7708e4.png";